module.exports = __webpack_public_path__ + "img/shixue.c3029def.png";